import { DEFAULT_CONFIG } from '../core/config.js';

/**
 * Utilitaires pour le widget
 */
export const Utils = {
  mergeConfig: function (userConfig) {
    const windowConfig = window.RingadoConfig || {};
    const scriptConfig = this.getScriptConfig();

    return {
      ...DEFAULT_CONFIG,
      ...scriptConfig,
      ...windowConfig,
      ...userConfig,
      callbacks: {
        ...DEFAULT_CONFIG.callbacks,
        ...(scriptConfig.callbacks || {}),
        ...(windowConfig.callbacks || {}),
        ...(userConfig.callbacks || {}),
      },
    };
  },

  getScriptConfig: function () {
    const script =
      document.querySelector('script[src*="ringado-chat-widget.js"]') ||
      document.querySelector('script[src*="main.js"]') ||
      document.querySelector('script[data-operator-id]') ||
      document.querySelector('script[operator-id]') ||
      document.currentScript;

    if (!script) return {};

    // When data-operator-id or operator-id is used in script tag, it refers to targetOperatorId (the operator to chat with)
    const operatorIdAttr =
      script.getAttribute('data-operator-id') ||
      script.getAttribute('operator-id');

    return {
      operatorId: operatorIdAttr,
      userId:
        script.getAttribute('data-user-id') || script.getAttribute('user-id'),
      targetOperatorId:
        operatorIdAttr ||
        script.getAttribute('data-target-operator-id') ||
        script.getAttribute('target-operator-id'),
      baseUrl:
        script.getAttribute('data-base-url') || script.getAttribute('base-url'),
      requireEmail:
        (script.getAttribute('data-require-email') ||
          script.getAttribute('require-email')) === 'true',
      isPro:
        (script.getAttribute('data-is-pro') ||
          script.getAttribute('is-pro')) === 'true'
          ? true
          : (script.getAttribute('data-is-pro') ||
              script.getAttribute('is-pro')) === 'false'
          ? false
          : undefined,
      debug:
        (script.getAttribute('data-debug') || script.getAttribute('debug')) ===
        'true',
    };
  },

  createElement: function (tag, className, innerHTML) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (innerHTML) element.innerHTML = innerHTML;
    return element;
  },

  generateId: function () {
    return 'ringado_' + Math.random().toString(36).substr(2, 9);
  },

  isInViewport: function (element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= window.innerHeight &&
      rect.right <= window.innerWidth
    );
  },
};
